import { selector } from './selector';
import * as events from "./events";
import { HrTagsLoader } from './hr-tags';

const PageCustomerProfileCards = (function ($) {

    function checkTerms() {
        $(selector.btnSubmitMK).prop('disabled', !$(selector.checkTerms).is(':checked'));
        $(selector.btnSubmitME).prop('disabled', !$(selector.checkTermsME).is(':checked'));
        $(selector.btnSubmitARS).prop('disabled', !$(selector.checkTermsARS).is(':checked'));
        $(selector.btnSubmitHR).prop('disabled', !$(selector.checkConsentHR).is(':checked'));
        $(selector.tagsHR).prop('disabled', !$(selector.checkConsentHR).is(':checked'));
    }

    function initEvents() {
        $(document).on('click', selector.btnCardDelete, events.removeCardModal);
        $(document).on('click', selector.btnChangeDefault, events.setDefaultCard);
        $(document).on('shown.bs.tab', '[data-bs-target="#tab_hr"]', function () {
            HrTagsLoader.init();
        });
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);
        if ($('#tab_hr').hasClass('active')) {
            HrTagsLoader.init();
        }
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageCustomerProfileCards };